import { useState } from 'react';
import { MODEL_TYPES } from '../constants/constants';
import { useUserContext } from '../contexts/UserContext';
import { useModelActions } from './useModelActions';
import { errorToast, successToast } from '../helpers/toastHelper';
import { useInfoDialogaActions } from './useInfoDialogaActions';
import { warningToast } from '../helpers/toastHelper';
import { isAdminOrOwner } from '../helpers/userHelper';
import { dispatcher } from '../helpers/projectHelper';
import { closeInfoDialog } from '../redux/slicers/infoDialogSlicer';
import { productBuilderListSelectors } from '../redux/slicers/productBuilderListSlicer';
import { deleteProductBuilderApi, productBuilderUpdateApi } from '../api/productBuilderApis';
import { useCheckCuratorActive } from './useCuratorActive';
import { getCurrentlyOpenProjectId } from '../helpers/jsHelper';
import { deleteMattress } from '../components/admin/curator/ProductBuilderComponents/userPilotEventsMattressBuilder';

export const useProductBuilderActions = ({ item }) => {
  const { currentUser } = useUserContext();
  const { openInfoDialog } = useInfoDialogaActions();
  const { deleteProductBuilder, deleteSucess } = useDeleteProductBuilder({ item });
  const { favouriteLoading, onFavouriteToggle, onShare, addToCollection } = useModelActions({
    item,
    modelType: MODEL_TYPES.PRODUCT_BUILDER,
    selectors: productBuilderListSelectors,
    updateApi: productBuilderUpdateApi,
    deleteConfig: {
      title: `Do you want to delete ${item?.name}?`,
      deleteApi: deleteProductBuilder,
    },
  });
  const { isCuratorActive, getCuratorList } = useCheckCuratorActive();
  const isActiveCurator = async () => {
    const curatorActive = await isCuratorActive();
    return curatorActive;
  };

  const onDelete = async (id) => {
    const { member_details, name } = item;
    const openCurator = await isActiveCurator();
    const isActive =
      openCurator &&
      getCurrentlyOpenProjectId(
        getCuratorList()?.map((url) => url?.uniqueUrl),
        item.id
      );
    if (isActive) {
      errorToast('Please close or save this project before deleting');
      return;
    }
    if (!isAdminOrOwner(currentUser) && member_details.id !== currentUser.id) {
      warningToast('You do not have ownership to delete this item', {
        toastId: `CAN_NOT_DELETE_${item.id}`,
      });
      return;
    }
    openInfoDialog({
      title: `Do you want to delete ${name || 'this mattress builder'}?`,
      description: 'Your item can be restored from the Trash area.',
      cancelButtonText: 'No',
      buttonText: 'Yes',
      onButtonClick: () => {
        deleteProductBuilder(id);
      },
    });
  };

  return {
    onDelete,
    onFavouriteToggle,
    favouriteLoading,
    onShare,
    addToCollection,
    deleteSucess,
  };
};

export const useDeleteProductBuilder = ({ item }) => {
  const [loading, setLoading] = useState(false);
  const [deleteSucess, setDeleteSuccess] = useState(false);

  const deleteProductBuilder = async (idOrList) => {
    if (loading) return;
    setLoading(true);
    setDeleteSuccess(false);
    let res = await deleteProductBuilderFile(idOrList);
    if (res) {
      successToast('Mattress builder deleted successfully');
      closeInfoDialog();
      setDeleteSuccess(true);
      deleteMattress({
        id: item?.id,
        name: item?.name,
        actionFrom: 'Card Option',
      });
    }
    setLoading(false);
  };

  return { deleteProductBuilder, deleteLoading: loading, deleteSucess: deleteSucess };
};

const deleteProductBuilderFile = async (idOrList) => {
  const formData = new FormData();
  let res;
  if (Array.isArray(idOrList)) {
    idOrList.forEach((id) => {
      formData.append('id', id);
    });
  } else {
    res = await dispatcher(deleteProductBuilderApi(idOrList));
  }
  return res;
};
